





































import { Component, Prop, Vue } from "vue-property-decorator";
import { EditWoodInfo } from "./edit/types/edit-wood-info";
import { valueOrEmpty } from "../../../../utils/number";

@Component
export default class WoodInfo extends Vue {
  @Prop() woodInfo!: EditWoodInfo;

  private showValueOrEmpty(val: any) {
    return valueOrEmpty(val);
  }
}
